/**
 * Vuex module to sort SMS conversations
 */

import ChatLocalStorage from '@/api/chat'

const actions = {
  setProperty ({ commit }, property) {
    commit('SET_PROPERTY', property)
    ChatLocalStorage.setGroupsSortProperty(property)
    this.dispatch('chat/GroupsSortByFilter/sortGroups')
  },
  setDirection ({ commit }, direction) {
    commit('SET_DIRECTION', direction)
    ChatLocalStorage.setGroupsSortDirection(direction)
    this.dispatch('chat/GroupsSortByFilter/sortGroups')
  },
  sortGroups () {
    this.dispatch('chat/getGroups')
  },
  init ({ commit }) {
    commit('SET_PROPERTY', ChatLocalStorage.groupsSortProperty())
    commit('SET_DIRECTION', ChatLocalStorage.groupsSortDirection())
  }
}

const mutations = {
  SET_PROPERTY (state, property) {
    state.property = property
  },
  SET_DIRECTION (state, direction) {
    state.direction = direction
  }
}

const state = {
  directions: ['asc', 'desc'],
  property: 'recent_activity',
  direction: 'asc'
}

const getters = {
  directions: state => state.directions,
  property: state => state.property,
  direction: state => state.direction
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
